import React from 'react';
import { css } from '@emotion/react';
import useTranslation from 'next-translate/useTranslation';

const SpeechBubble = () => {
  const { t } = useTranslation();
  return (
    <div css={styles.container}>
      <div css={styles.bubble}>
        <div css={styles.text}>
          {t('storygame_ai_onboarding_screen_description_make_my_character')}
        </div>
      </div>
      <div css={styles.logo}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <circle cx="10" cy="10" r="8.75" fill="#FF3A58" />
          <path
            d="M6.96582 13.4913V6.5083L13.0351 13.4913V6.5083"
            stroke="white"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    </div>
  );
};

const styles = {
  container: css`
    display: flex;
  `,
  logo: css`
    width: 20px;
    height: 20px;
    z-index: 2;
    position: absolute;
    left: -10px;
    top: -10px;
  `,
  bubble: css`
    background-color: white;
    border-radius: 4px;
    padding: 8px;
    position: relative;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);

    &:after {
      content: '';
      position: absolute;
      right: -8px;
      top: 50%;
      width: 16px;
      height: 16px;
      background-color: white;
      transform: translateY(-50%) rotate(45deg);
      box-shadow: 2px -2px 2px rgba(0, 0, 0, 0.05);
    }
  `,
  text: css`
    font-size: 12px;
    line-height: 1.4;
    color: #333;
    text-align: left;
  `,
};

export default SpeechBubble;
